import { Box, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { ReactNode } from 'react'
import { useDetailsGridRails } from '../../hooks/useDetailsGridRails'
import { YardViewStore } from '../../stores/yard.view-store'
import { BayGapCell } from './BayGapCell'

interface Props {
  viewStore: YardViewStore
  selectedBay?: number
  columns: string[]
}
export const YardBlockContainerDetailsFooter = observer(
  ({ viewStore, selectedBay, columns }: Props) => {
    const theme = useMinimalsTheme()
    const { t } = useTranslate()

    const columnLength = columns.length || 1
    const { rails, totalCssColumns, gridTemplateColumns, cssColumnForDataIndex } =
      useDetailsGridRails(viewStore, columnLength)

    if (columns.length === 0) return null

    const cells: ReactNode[] = []

    if (rails.leading) {
      cells.push(
        <BayGapCell
          key='footer-rail-leading'
          gap={rails.leading}
          variant='ghost'
          sx={{ gridColumn: '1', gridRow: '1' }}
        />,
      )
    }

    if (rails.trailing) {
      cells.push(
        <BayGapCell
          key='footer-rail-trailing'
          gap={rails.trailing}
          variant='ghost'
          sx={{ gridColumn: `${totalCssColumns}`, gridRow: '1' }}
        />,
      )
    }

    rails.inner.forEach((gap, dataIdx) => {
      const gapCol = cssColumnForDataIndex(dataIdx) + 1
      cells.push(
        <BayGapCell
          key={`footer-rail-gap-${dataIdx}`}
          gap={gap}
          variant='ghost'
          sx={{ gridColumn: `${gapCol}`, gridRow: '1' }}
        />,
      )
    })

    columns.forEach((xLabel, xIndex) => {
      const cssCol = cssColumnForDataIndex(xIndex + 1)
      cells.push(
        <Box
          key={`x-axis-label-${xIndex}`}
          sx={{
            gridColumn: `${cssCol}`,
            gridRow: '1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant='captionBold'>
            {selectedBay ? t('row', 'Row') : t('bay', 'Bay')} {xLabel}
          </Typography>
        </Box>,
      )
    })

    return (
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns,
          gridTemplateRows: '1fr',
          gap: theme.customSpacing.s,
        }}
      >
        {cells}
      </Box>
    )
  },
)
